import { all } from 'redux-saga/effects'
import { calendarSaga, systemConfigSaga, userSaga, suppliersSaga } from 'redux/sagas'

export function* rootSaga() {
    yield all([...systemConfigSaga, ...userSaga, ...calendarSaga, ...suppliersSaga])
}
